import { connect } from 'react-redux';
import DataGridMVP from './DataGridMVP';
import { modalSelectFieldsOpen } from '../../store/actions/modal';

const mapStateToProps = () => ({});
const mapDispatchToProps = { modalSelectFieldsOpen };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataGridMVP);
